import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "p-text-md",
  style: {"color":"#AAA"}
}
const _hoisted_2 = { class: "p-text-md" }

import {computed} from 'vue'

import moment from "moment";


export default /*@__PURE__*/_defineComponent({
  __name: 'FormField',
  props: {
  modelValue: {
    type: String,
    required: true,
  },
  editting: {
    type: Boolean,
    required: false,
    default: false,
  },
  label: {
    type: String,
    required: true,
  },
  first: {
    type: Boolean,
    required: false,
    default: false,
  },
  last: {
    type: Boolean,
    required: false,
    default: false,
  },
  border: {
    type: Boolean,
    default: true,
  },
  type: {
    type: String,
    default: 'text',
  },
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const props = __props;

const value = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit('update:modelValue', value)
  }
})

const formattedDate = (value: string | number, format = 'YYYY-MM-DD') => {
  return moment(value).format(format)
}

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_sheet = _resolveComponent("v-sheet")!

  return (__props.editting)
    ? (_openBlock(), _createBlock(_component_v_sheet, {
        key: 0,
        class: "px-2 py-1"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_text_field, {
            modelValue: value.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
            label: __props.label,
            type: __props.type,
            variant: "outlined"
          }, null, 8, ["modelValue", "label", "type"])
        ]),
        _: 1
      }))
    : (_openBlock(), _createBlock(_component_v_sheet, {
        key: 1,
        class: _normalizeClass([{'border-b': __props.border}, "d-flex justify-space-between px-5 py-3"])
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_sheet, null, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_1, _toDisplayString(__props.label), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_sheet, { class: "text-right" }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_2, _toDisplayString(__props.type === 'date' ? formattedDate(value.value, 'DD/MM/YYYY') : value.value), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class"]))
}
}

})